import { Fragment } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { __CERTIFICATION_API_URL__ } from 'shell/constants/environment';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import Form, { ReleaseModeForm } from 'front-office/components/release-mode/form';
import { HttpResponse } from 'shell/models/http-response';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { transformReleaseMode } from 'front-office/components/release-mode/utils/transform-release-mode';
import { ReleaseModeCrumbs } from 'front-office/constants/release-mode-crumbs';
import { noop } from 'shell/utils/noop';
import { ReleaseMode } from 'shell/models/release-mode';

const ReleaseModeDetail = (): React.ReactElement => {
  const params = useParams();

  const [releaseMode] = useHttpFetch<HttpResponse<ReleaseMode>, ReleaseModeForm>(
    `${__CERTIFICATION_API_URL__}/certificazione/modalita-rilascio/${params.id}`,
    {
      onBootstrap: true,
      options: {
        errorCatching: true,
        method: 'GET',
        loading: true,
        data: {},
      },
      transformer: transformReleaseMode,
    }
  );

  const navigate = useNavigate();

  const loading = releaseMode.isLoading || releaseMode.pristine || releaseMode.hasErrors;

  return (
    <Fragment>
      <Breadcrumbs items={[...ReleaseModeCrumbs, { name: 'Dettaglio modalità rilascio' }]} />
      {loading ? null : (
        <Form
          title="Dettaglio modalità rilascio"
          onOk={noop}
          initialValues={releaseMode.data as ReleaseModeForm}
          onCancel={() => {
            navigate('/sportello/modalita-rilascio');
          }}
          disabled
        />
      )}
    </Fragment>
  );
};

ReleaseModeDetail.displayName = 'Release Mode detail page component';

export default ReleaseModeDetail;
